if (!customElements.get('product-card-variants')) {
  customElements.define(
    'product-card-variants',
    class ProductCardVariants extends HTMLElement {
      connectedCallback() {
        this.onClick ||= this.handleClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.defaultPrice ||= this.querySelector('[data-card-price]')?.cloneNode(true);
        this.prioritizeAvailableSwatches();
        this.initializeSlider();

        const selectedSwatch = this.querySelector('.card-color-swatch[aria-pressed="true"]');
        this.selectVariant(selectedSwatch || this, 0);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.querySelector('.swiper-collection')?.swiper?.destroy();
      }

      prioritizeAvailableSwatches() {
        this.querySelectorAll('.card-color-swatches').forEach((wrapper) => {
          const swatches = Array.from(wrapper.querySelectorAll('.card-color-swatch'));
          const moreButton = wrapper.querySelector('.swatch-more');
          swatches.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
          swatches.forEach((swatch) => wrapper.insertBefore(swatch, moreButton));
        });
      }

      initializeSlider() {
        const slider = this.querySelector('.swiper-collection');
        if (!slider || slider.swiper || typeof Swiper === 'undefined') return;

        const mediaId = this.dataset.selectedMedia || this.dataset.mediaId;
        const initialSlide = Array.from(slider.querySelectorAll('.swiper-slide')).findIndex(
          (slide) => slide.dataset.mediaId === mediaId
        );

        new Swiper(slider, {
          initialSlide: Math.max(0, initialSlide),
          slidesPerView: 1,
          spaceBetween: 0,
          nested: true,
          watchSlidesProgress: true,
          passiveListeners: false,
          pagination: {
            el: slider.querySelector('.swiper-scrollbar'),
            type: 'progressbar',
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next.card-media-button'),
            prevEl: slider.querySelector('.swiper-button-prev.card-media-button'),
          },
        });
      }

      handleClick(event) {
        const moreButton = event.target.closest('.swatch-more');
        if (moreButton) {
          event.preventDefault();
          event.stopPropagation();
          moreButton.closest('.card-color-swatches').classList.add('expanded');
          moreButton.remove();
          return;
        }

        const swatch = event.target.closest('.card-color-swatch');
        if (!swatch) return;

        event.preventDefault();
        event.stopPropagation();
        this.selectVariant(swatch);
      }

      selectVariant(swatch, speed = 300) {
        this.dataset.selectedVariant = swatch.dataset.variant;
        this.dataset.selectedMedia = swatch.dataset.mediaId;
        this.querySelectorAll('.card-color-swatch').forEach((option) => {
          option.setAttribute('aria-pressed', String(option.dataset.variant === swatch.dataset.variant));
        });

        this.querySelectorAll('[data-card-product-link]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', swatch.dataset.variant);
          link.href = url.href;
        });

        const price = this.querySelector('[data-card-price]');
        const variantPrice = swatch === this ? this.defaultPrice : swatch.querySelector('[data-card-variant-price]')?.content;
        if (price && variantPrice) price.replaceChildren(...variantPrice.cloneNode(true).childNodes);

        const soldOut = swatch.dataset.available === 'false';
        this.querySelectorAll('[data-card-sold-out-badge]').forEach((badge) => {
          badge.classList.toggle('hidden', !soldOut);
        });
        this.querySelectorAll('[data-card-default-badge]').forEach((badge) => {
          badge.classList.toggle('hidden', soldOut);
        });

        const slider = this.querySelector('.swiper-collection');
        if (!slider) return;

        this.initializeSlider();
        const slides = Array.from(slider.querySelectorAll('.swiper-slide'));
        const index = slides.findIndex((slide) => slide.dataset.mediaId === swatch.dataset.mediaId);
        if (index < 0) return;

        if (slider.swiper) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          slider.swiper.slideTo(index, reduceMotion ? 0 : speed);
        }
      }
    }
  );
}
